import { RemoteFile } from '@models/next/FileType';
import { z } from 'zod';

export const CustomsStatusName = z.enum([
  '予備申入り 区1',
  '予備申入り 区2',
  '予備申入り 区3',
  '本申告入り 区1',
  '本申告入り 区2',
  '本申告入り 区3',
  '税関検査',
  '輸入許可',
]);

export type CustomsStatusName = z.infer<typeof CustomsStatusName>;

export const CustomsRequestStatusName = z.enum([
  '通関依頼書作成済',
  '通関リンク作成済',
  '通関依頼書送信済',
  '通関準備中',
  // '予備申入り 区1',
  // '予備申入り 区2',
  // '予備申入り 区3',
  // '本申告入り 区1',
  // '本申告入り 区2',
  // '本申告入り 区3',
  // '税関検査',
  // '輸入許可',
]);

export type CustomsRequestStatusName = z.infer<typeof CustomsRequestStatusName>;

export const CustomsRequestStatus = z.object({
  name: z.union([CustomsStatusName, CustomsRequestStatusName]),
  attached_file: RemoteFile.nullish(),
  time: z.string(),
});

export type CustomsRequestStatus = z.infer<typeof CustomsRequestStatus>;

export const getCustomsStatusLabel = (status: CustomsStatusName) => {
  return status;
};

export const getCustomsRequestStatusLabel = (status: CustomsRequestStatusName) => {
  return status === '通関依頼書送信済' ? '未申告' : status;
};
